var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"select-custom"},[_c('p',[_vm._v(_vm._s(_vm.name))]),_c('span',{staticClass:"icon-chevron-down-outline",class:{ 'open' : _vm.collapse },on:{"click":function($event){_vm.collapse = !_vm.collapse}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }